// https://caniuse.com/devicepixelratio
export const devicePixelRatio = __CLIENT__ ? window.devicePixelRatio ?? 1 : 1;
export const roundedDevicePixelRatio = Math.round(devicePixelRatio);

// https://caniuse.com/mdn-api_contactsmanager
export const contactPickerSupported =
  __CLIENT__ && 'contacts' in navigator && 'ContactsManager' in window;
